import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { viewerModel } from '~/entities/Viewer'
import { Button } from '~/shared/ui/Buttons'
import { Wrapper, Title } from './styled'

export function AlreadyAuthorized() {
  const { t } = useTranslation()

  const isLogoutPending = useStore(viewerModel.logoutFx.pending)

  return (
    <Wrapper>
      <Title>{t('alert.already authorized')}</Title>
      <Button
        variant='primaryOutline'
        fullWidth
        routerLink='/'
        disabled={isLogoutPending}
      >
        {t('button.go to main page')}
      </Button>

      <Button
        loading={isLogoutPending}
        fullWidth
        onClick={() => viewerModel.signOut()}
      >
        {t('button.exit')}
      </Button>
    </Wrapper>
  )
}
